export const SELECTED_CITY = 'SELECTED_CITY';
export const FAVORITES_CITY = 'FAVORITES_CITY';